import { SEARCH_QUERY } from "../../../../Utils/AllPagesQuriesAndMutations";

const placeMasterConfig = [
  {
    name: "Place_Master_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Place",
        label: " Location",
        masterName: "GoogleLocation",
        type: "GoogleSearch",
        notSearchable: true,
        dropdowncontent: SEARCH_QUERY,
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "displayName",
        label: "Display Name",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "googlePlaceId",
        label: "Google Place Id",
        type: "text",
        min: 2,
        FirstCharCap: true,

        isRequired: true,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "type",
        label: "Type",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "formattedAddress",
        label: "Formatted Address",
        type: "textarea",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "sublocalityLevel2",
        label: "Sublocality Level 2",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "sublocalityLevel1",
        label: "Sublocality Level 1",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "locality",
        label: "Locality",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "administrativeAreaLevel3",
        label: "Administrative Area Level 3",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "administrativeAreaLevel2",
        label: "Administrative Area Level 2",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "administrativeAreaLevel1",
        label: "Administrative Area Level 1",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "country",
        label: "Country",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "postalCode",
        label: "Postal Code",
        type: "text",
        min: 2,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "latitude",
        label: "Latitude",
        type: "number",
        min: 1,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "longitude",
        label: "Longitude",
        type: "number",
        min: 1,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "googleAPIResponseString",
        label: "API Response",
        type: "textarea",
        min: 2,
        isRequired: true,
        FirstCharCap: true,
      },
    ],
  },
];

export { placeMasterConfig };

// {
//     id: Math.random() * 10,
//     name: "Sidebyside",
//     Subfields: [
//       {
//         id: Math.random() * 10,
//         name: "Dimension",
//         label: "Dimension(L×W×H)",
//         type: "inputMask",
//         mask: "99 x *9 x *9",
//         inputBoxNumber: 3,
//         inputDigitLimit: 3,
//         min: 1,
//         max: Infinity,
//         // type:"DimensionsMask",
//       },
//       {
//         id: Math.random() * 10,
//         name: "Inc_CMS",
//         label: "Inc/CMS",
//         type: "inputdrop",
//         dropdowncontent: ["in", "cm"],
//         min: 1,
//         max: Infinity,
//       },
//     ],
//   },
